import { instance } from './index';

const contextPath = '/admin/auth'

export const adminLogin = async (param) => {
    return await instance.post(contextPath+'/login', param);

}

export const pwdChange = async (param) => {
    return await instance.post(contextPath+'/pwdChange', param);

}